// File: src/components/EarthImage.jsx
import React from "react";
import { motion } from 'framer-motion';
const Earth = '/theme-images/1.png';
//const Earth = 'https://upload.wikimedia.org/wikipedia/commons/9/97/The_Earth_seen_from_Apollo_17.jpg';

export default function EarthImage() {
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.5 }}
            className="mt-10 flex justify-center"
        >
            <img src={Earth} alt="Earth from space" className="w-[500px] md:w-[800px]" />
        </motion.div>
    );
}


